import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { CtaAnchor } from "@/src/common/components/cta-link";
import { Reveal } from "@/src/common/components/reveal";
import { SectionHeading } from "@/src/common/components/section-heading";
import { APP_LINKS } from "@/src/common/constants/app-links";
import { env } from "@/src/common/constants/env";

export function FinalCta() {
	const { t } = useTranslation("home");

	return (
		<section className="bg-dark-hero relative isolate overflow-hidden py-24 md:py-32">
			<div aria-hidden="true" className="mesh-layer mesh-layer-a" />
			<div aria-hidden="true" className="mesh-layer mesh-layer-b" />
			<div aria-hidden="true" className="absolute inset-0 bg-grid opacity-40" />

			<div className="relative mx-auto flex max-w-3xl flex-col items-center gap-8 px-4 text-center sm:px-6 lg:px-8">
				<SectionHeading
					tone="white"
					title={t("final_cta.title")}
					titleAccent={t("final_cta.title_accent")}
					description={t("final_cta.body")}
				/>

				<Reveal delay={0.15} className="flex flex-col items-center gap-3 sm:flex-row">
					<CtaAnchor href={APP_LINKS.SIGN_UP} variant="gradient" size="lg" endContent={<ArrowRight className="h-4 w-4" />}>
						{t("final_cta.cta_primary")}
					</CtaAnchor>
					<CtaAnchor href={env.CALENDLY_URL} target="_blank" rel="noreferrer" variant="outline-dark" size="lg">
						{t("final_cta.cta_secondary")}
					</CtaAnchor>
				</Reveal>

				<Reveal delay={0.25}>
					<p className="text-xs text-white/60 sm:text-sm">{t("final_cta.footnote")}</p>
				</Reveal>
			</div>
		</section>
	);
}
